import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import {
    GetAllDeliveryTerms, GetAllPackingTypes,
    GetAllPaymentTerms, GetAllProductNames,
    GetAllShippingModes, GetAllSuppliers, CreatePurchaseOrder,
    UpdatePurchaseOrder, GetAllPfiList, GetIncrementedPoNumber
} from '../../shared/common/graphqlQuery';
import { transformEachApiDataKeyValue } from '../../shared/hooks/transfromApiData';
import { companyData } from '../../core/auth';
import { dateFormat, routeConfig } from '../../shared/common/constant';
import './addEditPurchaseOrder.scss';
import { Select, Input, DatePicker, Button, Form, Space, InputNumber, Checkbox, message } from 'antd';
import { DeleteTwoTone, LoadingOutlined } from '@ant-design/icons';
import { convertNumTOWords } from '../../shared/hooks/wordNumb';
import moment from 'moment';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { api, useStore } from '../../shared/hooks/stateStore';
import cloneDeep from 'lodash/cloneDeep';
import { hideSuggestions, roundOffDigits, validateNameMessages } from '../../shared/hooks/utils';
import signature from '../../assets/AuthorizedSignature.png'

const renderOption = (eachOption: any) => {
    return (
        <Select.Option value={eachOption.key ? eachOption.key : eachOption.value}
            key={eachOption.key ? eachOption.key : eachOption.value}>
            {eachOption.value}
        </Select.Option>
    )
}


let tableRowdataDelivery = [];
let tableRowdataPackingTypes = [];
let tableRowdataPaymentTerms = [];
let tableRowdataShippingModes = [];
let tableRowdataProductName = [];
let tableRowdataConsignee = [];
let tablePfiInvoices = [];
const consigneeConst: any = {
    name: '',
    address: '',
    country: '',
    email: '',
    phoneNumber: ''
};

const tableTaxTypes = [
    { key: 1, value: 'SGST-CGST' },
    { key: 2, value: 'IGST' },
    { key: 3, value: 'Exempt' }
]
let taxFirstValue = 0;
let taxSecondValue = 0;
let purchaseOrderStoreData;
let tableRowdataCurrency = [];
const AddEditPurchaseOrder = () => {
    const companyId = companyData().getCompanyData();
    const [currencyData, setcurrencyData] = useState<any>([]);
    let { purchaseOrderInvoiceId } = useParams<any>();
    const [gstNotificationState, setGstNotificationState] = useState<string>('(CBEC Notification 40/2017 Central Tax Rate 23 Oct-2017)');
    const [buyerSameCheckBox, setBuyerSameCheckBox] = useState<boolean>(false);
    const [selectedCurrency, setSelectedCurrency] = useState<string>('');
    const [consigneeDetails, setConsigneeDetails] = useState(consigneeConst);
    const [roundOff, setRoundOff] = useState<number>();
    const [taxTypeValue, setTaxTypeValue] = useState<number>(1);
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        fetch('https://openexchangerates.org/api/currencies.json')
            .then(response => response.json())
            .then(data => Object.entries(data).map(([key, value], index) => {
                tableRowdataCurrency.push({ key, value });
                if (index === (Object.keys(data).length - 1)) {
                    setcurrencyData(tableRowdataCurrency);
                }
            }));
        taxFirstValue = 0;
        taxSecondValue = 0;
        purchaseOrderStoreData = cloneDeep(useStore.getState().purchaseOrder);
        if (location.pathname.split('/').length === 3) {
            if (!purchaseOrderStoreData) {
                history.push(routeConfig.purchaseOrderList.path)
            } else {

                purchaseOrderInvoiceId = purchaseOrderStoreData['_id']
                // purchaseOrderStoreData.date = moment(purchaseOrderStoreData.date, dateFormat);
                purchaseOrderStoreData.poDate = moment(purchaseOrderStoreData.poDate, dateFormat);
                purchaseOrderStoreData.invoiceNumber = purchaseOrderStoreData.invoiceNumber['_id']
                setConsigneeDetails({
                    name: purchaseOrderStoreData.businessPartnerId.name,
                    address: purchaseOrderStoreData.businessPartnerId.address,
                    country: purchaseOrderStoreData.businessPartnerId.country,
                    email: purchaseOrderStoreData.businessPartnerId.email,
                    phoneNumber: purchaseOrderStoreData.businessPartnerId.phoneNumber
                });
                // purchaseOrderStoreData.exporterRefNo = purchaseOrderStoreData.exporterRefNo['_id'];
                purchaseOrderStoreData.businessPartnerId = purchaseOrderStoreData.businessPartnerId['_id'];

                purchaseOrderStoreData.paymentTerms = purchaseOrderStoreData.paymentTerms['_id'];
                purchaseOrderStoreData.deliveryTerms = purchaseOrderStoreData.deliveryTerms['_id'];
                purchaseOrderStoreData.shippedVia = purchaseOrderStoreData.shippedVia['_id']

                purchaseOrderStoreData.purchaseOrderItemDetails.map(eachPfiItemData => {
                    eachPfiItemData.packingTypes = eachPfiItemData.packingTypes['_id']
                    eachPfiItemData.descriptionOfGoods = eachPfiItemData.descriptionOfGoods['_id']
                    delete eachPfiItemData.__typename;
                    return eachPfiItemData;
                })
                const gstBracket = JSON.parse(purchaseOrderStoreData.gstBracket);

                purchaseOrderStoreData.taxType = +gstBracket.taxType;
                purchaseOrderStoreData.taxFirst = +gstBracket.taxFirst;
                taxFirstValue = purchaseOrderStoreData.taxFirst;
                purchaseOrderStoreData.taxSecond = +gstBracket.taxSecond;
                taxSecondValue = purchaseOrderStoreData.taxSecond;

                setTaxTypeValue(+gstBracket.taxType);
                purchaseOrderStoreData.amountSGST = roundOffDigits((taxFirstValue / 100) * purchaseOrderStoreData.amountTotalInInr);
                purchaseOrderStoreData.amountCGST = roundOffDigits((taxSecondValue / 100) * purchaseOrderStoreData.amountTotalInInr);
                purchaseOrderStoreData.amountInWords = convertNumWord(purchaseOrderStoreData.grandTotal, purchaseOrderStoreData.currency);
                const grandTotalRf = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * purchaseOrderStoreData.amountTotalInInr) + purchaseOrderStoreData.amountTotalInInr);
                const grandTotal = Math.floor(grandTotalRf);
                setRoundOff(roundOffDigits(grandTotal - grandTotalRf))
                form.setFieldsValue(purchaseOrderStoreData);
                gstNotificationChange();
                setSelectedCurrency(purchaseOrderStoreData.currency);
            }
        } else {
            purchaseOrderStoreData = {
                purchaseOrderItemDetails: [{}],
                taxType: 1,
                gstNotification: 'CBEC Notification 40/2017 Central Tax Rate 23 Oct-2017'
            };
            form.setFieldsValue(purchaseOrderStoreData);
        }
        const unsub = api.subscribe(state => {
            if (state.saveInvoice) {
                useStore.setState({ saveInvoice: 0, psiData: null });
                validate();
            }
        })
        hideSuggestions();
        return () => {
            // useStore.setState({ purchaseOrderData: null });
            unsub();

        }
    }, []);

    const redirectBack = () => {
        history.push(routeConfig.purchaseOrderList.path);
    }

    const onSubmittedPurchaseOrderDetails = () => {
        redirectBack();
    }
    const onError = ({ graphQLErrors, networkError }) => {
        console.log(graphQLErrors);
        console.log(networkError)
        if (graphQLErrors[0].message === 'ACTION_NOT_ALLOWED') {
            message.error('Duplicate Invoice No. Please change the Invoice No.')
        } else {
            message.error('Something went wrong. Please try again.');
        }
    }

    // CreateNewPurchaseOrder
    const PurchaseOrderMutation = useMutationHook(CreatePurchaseOrder, onSubmittedPurchaseOrderDetails, onError);
    const UpdatePurchaseOrderMutation = useMutationHook(UpdatePurchaseOrder, onSubmittedPurchaseOrderDetails, onError);

    const DeliveryTermsQuery = useQueryHook(GetAllDeliveryTerms, { companyId: companyId });
    const PackingTypesQuery = useQueryHook(GetAllPackingTypes, { companyId: companyId });
    const PaymentTermsQuery = useQueryHook(GetAllPaymentTerms, { companyId: companyId });
    const ProductNamesQuery = useQueryHook(GetAllProductNames, { companyId: companyId });
    const ShippingModesQuery = useQueryHook(GetAllShippingModes, { companyId: companyId });
    const ConsigneeQuery = useQueryHook(GetAllSuppliers, { companyId: companyId });
    const allConsineeData = ConsigneeQuery.data?.getAllSuppliers;
    const getPfiAllData = useQueryHook(GetAllPfiList, { companyId: companyId });

    tableRowdataDelivery = transformEachApiDataKeyValue(DeliveryTermsQuery.data?.getAllDeliveryTerms, 'deliveryTerm');
    tableRowdataPackingTypes = transformEachApiDataKeyValue(PackingTypesQuery.data?.getAllPackingTypes, 'packingType');
    tableRowdataPaymentTerms = transformEachApiDataKeyValue(PaymentTermsQuery.data?.getAllPaymentTerms, 'paymentTerm');
    tableRowdataShippingModes = transformEachApiDataKeyValue(ShippingModesQuery.data?.getAllShippingModes, 'shippingMode');
    tableRowdataProductName = transformEachApiDataKeyValue(ProductNamesQuery.data?.getAllProductNames, 'productName')
    tableRowdataConsignee = transformEachApiDataKeyValue(ConsigneeQuery.data?.getAllSuppliers, 'name');
    tablePfiInvoices = transformEachApiDataKeyValue(getPfiAllData.data?.getAllPFIs, 'invoiceNumber');


    const constPONumber = useQueryHook(GetIncrementedPoNumber, { companyId: companyId });
    if (purchaseOrderStoreData && !purchaseOrderStoreData['_id'] && constPONumber.data?.getIncrementedPoNumber) {
        purchaseOrderStoreData = {
            poNumber: constPONumber.data?.getIncrementedPoNumber
        };
        form.setFieldsValue(purchaseOrderStoreData);
    }

    const onNoPackageChange = (index) => {
        let purchaseOrderItemDetails = form.getFieldValue('purchaseOrderItemDetails');
        // count total quantity
        let consignmentTotalQuantity = 0;
        purchaseOrderItemDetails.map(eachListValue => {
            consignmentTotalQuantity += +eachListValue?.unitQuantity || 0;
        })

        // if(index !== -1) {
        // purchaseOrderItemDetails = countEachPfiItemsAmount(purchaseOrderItemDetails, index);
        // }
        const amountTotalInInr = countamountTotalInInr(purchaseOrderItemDetails);
        const grandTotal = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * amountTotalInInr) + amountTotalInInr);

        form.setFieldsValue({
            consignmentTotalQuantity: consignmentTotalQuantity,
            // purchaseOrderItemDetails: purchaseOrderItemDetails,
            amountTotalInInr: amountTotalInInr,
            amountSGST: roundOffDigits((taxFirstValue / 100) * amountTotalInInr),
            amountCGST: roundOffDigits((taxSecondValue / 100) * amountTotalInInr),
            grandTotal: grandTotal,
            amountInWords: convertNumWord(grandTotal, selectedCurrency)
        })
    }

    const onQuantityChange = (index) => {
        let purchaseOrderItemDetails = form.getFieldValue('purchaseOrderItemDetails');

        purchaseOrderItemDetails = countEachPfiItemsAmount(purchaseOrderItemDetails, index);
        const amountTotalInInr = countamountTotalInInr(purchaseOrderItemDetails);
        const grandTotalRf = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * amountTotalInInr) + amountTotalInInr);
            const grandTotal = Math.floor(grandTotalRf);
            setRoundOff(roundOffDigits(grandTotal - grandTotalRf))

        form.setFieldsValue({
            purchaseOrderItemDetails: purchaseOrderItemDetails,
            amountTotalInInr: amountTotalInInr,
            amountSGST: roundOffDigits((taxFirstValue / 100) * amountTotalInInr),
            amountCGST: roundOffDigits((taxSecondValue / 100) * amountTotalInInr),
            grandTotal: grandTotal,
            amountInWords: convertNumWord(grandTotal, selectedCurrency)
        })
    }

    const onPriceChange = (index) => {
        let purchaseOrderItemDetails = form.getFieldValue('purchaseOrderItemDetails');
        purchaseOrderItemDetails = countEachPfiItemsAmount(purchaseOrderItemDetails, index);
        const amountTotalInInr = countamountTotalInInr(purchaseOrderItemDetails);
        const grandTotalRf = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * amountTotalInInr) + amountTotalInInr);
            const grandTotal = Math.floor(grandTotalRf);
            setRoundOff(roundOffDigits(grandTotal - grandTotalRf))
        form.setFieldsValue({
            purchaseOrderItemDetails: purchaseOrderItemDetails,
            amountTotalInInr: amountTotalInInr,
            amountSGST: roundOffDigits((taxFirstValue / 100) * amountTotalInInr),
            amountCGST: roundOffDigits((taxSecondValue / 100) * amountTotalInInr),
            grandTotal: grandTotal,
            amountInWords: convertNumWord(grandTotal, selectedCurrency)
        })
    }

    const countamountTotalInInr = (purchaseOrderItemDetails) => {
        let amountTotalInInr = 0;
        purchaseOrderItemDetails.map(eachListValue => {
            amountTotalInInr += +eachListValue?.amount || 0;
        })
        return amountTotalInInr;
    }
    const convertNumWord = (amountTotalInInr, currency) => {
        return convertNumTOWords(amountTotalInInr, currency);
    }
    const countEachPfiItemsAmount = (purchaseOrderItemDetails, index) => {
        purchaseOrderItemDetails[index].amount = (+purchaseOrderItemDetails[index]?.quantityInMt || 0) * (+purchaseOrderItemDetails[index].priceInInr || 0)
        return purchaseOrderItemDetails;
    }

    const onChangeConsignee = () => {
        const businessPartnerId = form.getFieldValue('businessPartnerId');
        const indexConsignee = allConsineeData.findIndex(eachConsigneeData => eachConsigneeData['_id'] === businessPartnerId);
        const currentConsigneeDetail = allConsineeData[indexConsignee];
        setConsigneeDetails({
            name: currentConsigneeDetail.name,
            address: currentConsigneeDetail.address,
            country: currentConsigneeDetail.country,
            email: currentConsigneeDetail.email,
            phoneNumber: currentConsigneeDetail.phoneNumber
        });

        if (buyerSameCheckBox) {
            form.setFieldsValue({
                shipTo: {
                    name: currentConsigneeDetail.name,
                    address: currentConsigneeDetail.address
                }
            })
        }
    }

    const onFinish = (values: any) => {
        const purchaseOrderData = values;
        purchaseOrderData.date = moment(purchaseOrderData.date).format(dateFormat).toString();
        purchaseOrderData.poDate = moment(purchaseOrderData.poDate).format(dateFormat).toString();

        purchaseOrderData.gstBracket = JSON.stringify({
            taxType: purchaseOrderData.taxType,
            taxFirst: purchaseOrderData.taxFirst,
            taxSecond: taxSecondValue
        });

        delete purchaseOrderData.taxFirst;
        delete purchaseOrderData.taxSecond;
        delete purchaseOrderData.taxType;
        delete purchaseOrderData.amountInWords;
        delete purchaseOrderData.amountSGST;
        delete purchaseOrderData.amountCGST;

        if (!PurchaseOrderMutation.loading && !UpdatePurchaseOrderMutation.loading) {
            if (purchaseOrderStoreData && purchaseOrderStoreData['_id']) {
                UpdatePurchaseOrderMutation.callMutation({ variables: { companyId, purchaseOrderId: purchaseOrderStoreData['_id'], input: { ...purchaseOrderData, companyId, belongsTo: companyId } } })
            } else {
                PurchaseOrderMutation.callMutation({ variables: { purchaseOrderInput: { ...purchaseOrderData, companyId, belongsTo: companyId } } })
            }
        }
    }

    const validate = () => {
        form.validateFields().then(data => {
            onFinish(form.getFieldsValue());
        }
        ).catch(error => {

        });
    }
    const onChangeBuyer = (e) => {
        setBuyerSameCheckBox(e.target.checked);
        const businessPartnerId = form.getFieldValue('businessPartnerId');
        if (businessPartnerId) {
            form.setFieldsValue({
                shipTo: {
                    name: consigneeDetails.name,
                    address: consigneeDetails.address
                }
            });
        } else {
            message.warn('Please select Consignee. On selecting consingee, Buyer will be updated.');
        }
    }

    const onChangeTaxType = () => {
        const amountTotalInInr = form.getFieldValue('amountTotalInInr');
        setTaxTypeValue(form.getFieldValue('taxType'));

        if (form.getFieldValue('taxType') === 2) {
            taxSecondValue = 0;
        }
        if (amountTotalInInr) {
            const grandTotalRf = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * amountTotalInInr) + amountTotalInInr);
            const grandTotal = Math.floor(grandTotalRf);
            setRoundOff(roundOffDigits(grandTotal - grandTotalRf))
            form.setFieldsValue({
                taxSecond: taxSecondValue,
                amountCGST: roundOffDigits((taxSecondValue / 100) * amountTotalInInr),
                grandTotal: grandTotal,
                amountInWords: convertNumWord(grandTotal, selectedCurrency)
            })
        }
    }

    const onChangeTaxFirst = () => {
        taxFirstValue = +form.getFieldValue('taxFirst');
        const amountTotalInInr = form.getFieldValue('amountTotalInInr') || 0;

        if (!isNaN(taxFirstValue)) {
            const grandTotalRf = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * amountTotalInInr) + amountTotalInInr);
            const grandTotal = Math.floor(grandTotalRf);
            setRoundOff(roundOffDigits(grandTotal - grandTotalRf))
            form.setFieldsValue({
                amountSGST: roundOffDigits((taxFirstValue / 100) * amountTotalInInr),
                grandTotal: grandTotal,
                amountInWords: convertNumWord(grandTotal, selectedCurrency)
            })
        }
    }

    const onChangeTaxSecond = () => {
        taxSecondValue = +form.getFieldValue('taxSecond');
        const amountTotalInInr = form.getFieldValue('amountTotalInInr') || 0;
        if (!isNaN(taxSecondValue)) {
            const grandTotalRf = roundOffDigits((((taxFirstValue + taxSecondValue) / 100) * amountTotalInInr) + amountTotalInInr);
            const grandTotal = Math.floor(grandTotalRf);
            setRoundOff(roundOffDigits(grandTotal - grandTotalRf))
            form.setFieldsValue({
                amountCGST: roundOffDigits((taxSecondValue / 100) * amountTotalInInr),
                grandTotal: grandTotal,
                amountInWords: convertNumWord(grandTotal, selectedCurrency)
            })
        }
    }

    const onChangePfiInvoice = () => {
        const pfiId = form.getFieldValue('invoiceNumber');
        const pfiDataIndex = getPfiAllData.data?.getAllPFIs.findIndex(eachPfiData => eachPfiData['_id'] === pfiId);
        const currentPfiData = getPfiAllData.data?.getAllPFIs[pfiDataIndex];
        const purchaseOrderItemDetails = cloneDeep(currentPfiData.pfiItemDetails);
        purchaseOrderItemDetails.map(eachPfiItemData => {
            eachPfiItemData.packingTypes = eachPfiItemData.packingTypes['_id']
            eachPfiItemData.descriptionOfGoods = eachPfiItemData.descriptionOfGoods['_id']
            eachPfiItemData.quantityInMt = eachPfiItemData.quantity;
            delete eachPfiItemData.noOfPackages;
            delete eachPfiItemData.amount;
            delete eachPfiItemData.unitType;
            delete eachPfiItemData.quantity;
            delete eachPfiItemData.comments;
            delete eachPfiItemData.rate;
            delete eachPfiItemData.__typename;
            return eachPfiItemData;
        });
        form.setFieldsValue({
            date: moment(currentPfiData.date, dateFormat),
            shipTo: currentPfiData.buyer,
            // businessPartnerId: currentPfiData.businessPartner['_id'],
            shippedVia: currentPfiData.shippingMode['_id'],
            deliveryTerms: currentPfiData.deliveryTerms['_id'],
            paymentTerms: currentPfiData.paymentTerms['_id'],
            purchaseOrderItemDetails: purchaseOrderItemDetails,
            termsAndConditions: currentPfiData.termsAndConditions,
        });
        // setConsigneeDetails({
        //     name: currentPfiData.businessPartner.name,
        //     address: currentPfiData.businessPartner.address,
        //     country: currentPfiData.businessPartner.country,
        //     email: currentPfiData.businessPartner.email,
        //     phoneNumber: currentPfiData.businessPartner.phoneNumber
        // });
    }

    const gstNotificationChange = () => {
        const gstNotification = form.getFieldValue('gstNotification');
        setGstNotificationState(gstNotification);
    }

    const onChangeCurrency = () => {
        setSelectedCurrency(form.getFieldValue('currency'));
        form.setFieldsValue({
            amountInWords: convertNumWord(form.getFieldValue('grandTotal') || 0, form.getFieldValue('currency'))
        });
    }

    return (
        <Form name="basic" form={form} onFinish={onFinish} validateMessages={validateNameMessages} initialValues={null} className="form document-form" scrollToFirstError={true}>
            <div className="document-layout__page document-edit-view">
                <h3 className="document-layout__title">
                    Purchase Order
                </h3>
                <div className="whole__document document-layout__content">
                    <div className="document-layout__section exporter__ref__grid_purchase__label">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">PO No.</label>
                        </div>
                    </div>
                    <div className="document-layout__section exporter__ref__grid_purchase__key">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="poNumber" rules={[{ required: true, whitespace: true, message: 'PO No. is missing' }]} >
                                    <Input autoComplete="off" className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section invoice__date__grid_purchase__label">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">PO Date</label>
                        </div>
                    </div>
                    <div className="document-layout__section invoice__date__grid_purchase__key">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name='poDate' rules={[{ required: true, message: 'PO Date is missing' }]}>
                                    <DatePicker className="document-edit-block__input " format={dateFormat} placeholder={dateFormat} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section invoice__grid_purchase__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">PFI No.</label>
                        </div>
                    </div>
                    <div className="document-layout__section invoice__grid_purchase__key">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="invoiceNumber" rules={[{ required: true, whitespace: true, message: 'Invoice No. is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Invoice No."
                                        optionFilterProp="children"
                                        onChange={onChangePfiInvoice}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tablePfiInvoices.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  consignee__grid_purchase ">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">To</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="businessPartnerId" rules={[{ required: true, whitespace: true, message: 'TO is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Supplier"
                                        optionFilterProp="children"
                                        onChange={onChangeConsignee}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataConsignee.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="document-edit-block__content">
                                <div className="document-edit-block__contact">
                                    <div className="document-edit-block__contact-info">
                                        <div>{consigneeDetails.name}</div>
                                        <div>{consigneeDetails.address}</div>
                                        <div>{consigneeDetails.country}</div>
                                        <div>{consigneeDetails.email}</div>
                                        <div>{consigneeDetails.phoneNumber}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  buyer__grid_purchase">
                        <div className="document-edit-block">
                            <span className="document-edit-block__label">
                                <label>
                                    Ship TO
                                </label>
                                <span style={{ float: "right" }}>
                                    <Checkbox onChange={onChangeBuyer}>
                                        Same As Consignee
                                    </Checkbox>
                                </span>
                            </span>
                            <div className="document-edit-block__content">
                                <label className="document-edit-block__label">Name</label>
                                <div className="document-edit-block__content">
                                    <Form.Item name={['shipTo', 'name']} rules={[{ required: true, whitespace: true, message: 'Name is missing' }]}>
                                        <Input autoComplete="off" className="document-edit-block__input " disabled={buyerSameCheckBox} />
                                    </Form.Item>
                                </div>
                                <label className="document-edit-block__label">Address</label>
                                <div className="document-edit-block__content">
                                    <Form.Item name={['shipTo', 'address']} >
                                        {/* rules={[{ required: true, whitespace: true, message: 'Address is missing' }]} */}
                                        <Input className="document-edit-block__input " disabled={buyerSameCheckBox} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="document-layout__section  PO__date__grid_purchase">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">PO Date</label>
                            <div className="document-edit-block__content">
                                <Form.Item name='poDate' rules={[{ required: true, message: 'PO Date is missing' }]}>
                                    <DatePicker className="document-edit-block__input " format={dateFormat} placeholder={dateFormat} />
                                </Form.Item>
                            </div>
                        </div>
                    </div> */}
                    <div className="document-layout__section purchase_payment__term_grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Payment Terms</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="paymentTerms" rules={[{ required: true, whitespace: true, message: 'Payment Terms is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Payment Terms"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataPaymentTerms.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section purchase_FOB__grid_purchase">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">FOB/FOR Point</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="fobPoint" rules={[{ required: true, whitespace: true, message: 'FOB/FOR Point is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section purchase_delivery__term__grid_purchase">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Delivery Terms</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="deliveryTerms" rules={[{ required: true, whitespace: true, message: 'Delivery Terms is missing' }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Delivery Terms"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataDelivery.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  shipped__grid_purchase">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Shipped Via</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="shippedVia" rules={[{ required: true, whitespace: true, message: 'Shipped Via is missing' }]}>
                                    <Select
                                        showSearch
                                        // placeholder="Select Method of Dispatch"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataShippingModes.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section currency__grid_purchase">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Currency</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="currency" rules={[{ required: true, whitespace: true, message: "Currency is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Currency"
                                        optionFilterProp="children"
                                        onChange={onChangeCurrency}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {currencyData.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section product__table__grid_purchase">
                        <div className="document-edit-block__table">
                            <div className="document-edit-block__table-header">
                                <div className="document-edit-block__table-header-cell min_max_width_124">
                                    Qty in MT
                            </div>
                                <div className="document-edit-block__table-header-cell min_max_width_23">
                                    Description of Goods
                            </div>
                                <div className="document-edit-block__table-header-cell min_max_width_145">
                                    Packing Type
                            </div>
                                <div className="document-edit-block__table-header-cell min_max_width_125">
                                    Unit Quantity
                            </div>
                                {/* <div className="document-edit-block__table-header-cell min_max_width_126">
                                    Unit Type
                            </div> */}
                                <div className="document-edit-block__table-header-cell min_max_width_125">
                                    Price in {selectedCurrency}
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_125">
                                    Amount
                            </div>
                            </div>
                        </div>
                        <Form.List name="purchaseOrderItemDetails">
                            {(fields, { add, remove }) => {
                                return (
                                    <div>
                                        {fields.map((field, index) => (
                                            <>
                                                <Form.Item
                                                    required={false}
                                                    key={field.key}>
                                                    {fields.length > 1 ? (
                                                        <div className="document-edit-block__table-content-row-actions document-edit-block__table-content-row-actions--left">
                                                            <DeleteTwoTone
                                                                className="document-edit-block__table-content-row-action "
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                    onNoPackageChange(-1);
                                                                }}
                                                            />
                                                        </div>) : null}
                                                    <Space key={field.key} style={{ marginBottom: 8, width: '100%' }} align="start">
                                                        <div className="document-edit-block__table-content">
                                                            <div className="document-edit-block__table-content-row document-edit-block__table-content-row--draggable">
                                                                <div className="document-edit-block__table-content-cell min_max_width_124 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'quantityInMt']}
                                                                        fieldKey={[field.fieldKey, 'quantityInMt']}
                                                                        rules={[{ required: true, message: 'No Of Packages is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => onQuantityChange(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_23 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'descriptionOfGoods']}
                                                                        fieldKey={[field.fieldKey, 'descriptionOfGoods']}
                                                                        rules={[{ required: true, whitespace: true, message: ' is missing' }]}
                                                                    >
                                                                        {/* tableRowdataProductName */}
                                                                        <Select
                                                                            showSearch
                                                                            disabled
                                                                            placeholder="Description of Goods"
                                                                            optionFilterProp="children"
                                                                            // onChange={(event) => onChangeProductName(index)}
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataProductName.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_145 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'packingTypes']}
                                                                        fieldKey={[field.fieldKey, 'packingTypes']}
                                                                        rules={[{ required: true, whitespace: true, message: 'Packing Type is missing' }]}
                                                                    >
                                                                        <Select
                                                                            showSearch
                                                                            disabled
                                                                            placeholder="Packing Type"
                                                                            optionFilterProp="children"
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataPackingTypes.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_125 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'unitQuantity']}
                                                                        fieldKey={[field.fieldKey, 'unitQuantity']}
                                                                        rules={[{ required: true, message: 'Unit Quantity is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => onNoPackageChange(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                {/* <div className="document-edit-block__table-content-cell min_max_width_126 text__align__left">

                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'unitType']}
                                                                        fieldKey={[field.fieldKey, 'unitType']}
                                                                        rules={[{ required: true, whitespace: true, message: 'Unit Type is missing' }]}
                                                                    >
                                                                        <Input autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div> */}
                                                                <div className="document-edit-block__table-content-cell min_max_width_125 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'priceInInr']}
                                                                        fieldKey={[field.fieldKey, 'priceInInr']}
                                                                        rules={[{ required: true, message: 'Price is missing' }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => onPriceChange(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_125 text__align__right">
                                                                    <div className="dtotal__amount__div" >
                                                                        <Form.Item
                                                                            {...field}
                                                                            name={[field.name, 'amount']}
                                                                            fieldKey={[field.fieldKey, 'amount']}
                                                                            rules={[{ required: true, message: 'Amount is missing' }]}
                                                                        >
                                                                            <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                                                        </Form.Item>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Space>
                                                </Form.Item>
                                            </>
                                        ))}
                                        {/* <div className="flex">
                                            <div className="document-edit-block__table-button">
                                                <Button type="primary" ghost onClick={() => { add(); }}>
                                                    Add Line
                                                </Button>
                                            </div>
                                        </div> */}
                                    </div>
                                );
                            }}
                        </Form.List>
                    </div>
                    {/* Consignment Total Quantity */}
                    <div className="document-layout__section consignment__total__quantity__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Consignment Total Quantity</label>
                        </div>
                    </div>
                    <div className="document-layout__section consignment__total__quantity__number__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="consignmentTotalQuantity" rules={[{ required: true, message: 'Consignment Total Quantity is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section total__amount__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Amount Total({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section total__amount__number__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="amountTotalInInr" rules={[{ required: true, message: 'Amount Total is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section gst__notification__label pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">GST Notification</label>
                        </div>
                    </div>
                    <div className="document-layout__section gst__notification__value">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="gstNotification" >
                                    {/* rules={[{ required: true, whitespace: true, message: 'GST Notification is missing' }]} */}
                                    <Input autoComplete="off" className="document-edit-block__input " onChange={gstNotificationChange} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section tax__type__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Tax Type</label>
                        </div>
                    </div>
                    <div className="document-layout__section tax__type__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="taxType" rules={[{ required: true, message: 'Tax Type is missing' }]}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        onChange={onChangeTaxType}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableTaxTypes.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section sgst__words__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top"> {gstNotificationState}
                                {taxTypeValue === 1 ? ' SGST' : taxTypeValue === 2 ? ' IGST' : ''}</label>
                        </div>
                    </div>
                    <div className="document-layout__section sgst__words__tax__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="taxFirst" rules={[{ required: true, message: 'Tax Rate is missing' }]}>
                                    <InputNumber autoComplete="off" placeholder="Rate(%)" className="document-edit-block__input document-edit-block__input__number" onChange={onChangeTaxFirst} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section sgst__words__number__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="amountSGST" rules={[{ required: true, message: 'Tax is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    {
                        taxTypeValue === 1 ?
                            <>
                                <div className="document-layout__section cgst__words__label__grid_purchase pdf__label">
                                    <div className="document-edit-block" >
                                        <label className="document-edit-block__label label__margin__top">{gstNotificationState} CGST</label>
                                    </div>
                                </div>
                                <div className="document-layout__section cgst__words__tax__grid_purchase">
                                    <div className="document-edit-block" >
                                        <div className="document-edit-block__content">
                                            <Form.Item name="taxSecond" rules={[{ required: true, message: 'Tax Rate is missing' }]} >
                                                <InputNumber autoComplete="off" placeholder="Rate(%)" className="document-edit-block__input document-edit-block__input__number" onChange={onChangeTaxSecond} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="document-layout__section cgst__words__number__grid_purchase">
                                    <div className="document-edit-block" >
                                        <div className="document-edit-block__content">
                                            <Form.Item name="amountCGST" rules={[{ required: true, message: 'Tax is missing' }]}>
                                                <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : ''
                    }
                    <div className="document-layout__section round__off__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">ROUND OFF {selectedCurrency}</label>
                        </div>
                    </div>
                    <div className="document-layout__section round__off__number__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                {/* <Form.Item name="grandTotal" rules={[{ required: true, message: 'GRAND TOTAL is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item> */}
                                {roundOff}
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section grand_total__words__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">GRAND TOTAL in {selectedCurrency}</label>
                        </div>
                    </div>
                    <div className="document-layout__section grand_total__words__number__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="grandTotal" rules={[{ required: true, message: 'GRAND TOTAL is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section amount__words__label__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Amount in Words({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section amount__words__number__grid_purchase">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="amountInWords" rules={[{ required: true, message: 'Amount in Words is missing' }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section terms__condition__grid_purchase">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Terms &amp; Conditions</label>
                            <div className="document-edit-block__content">
                                <ol>
                                    <li> Please send two copies of your invoice to above mentioned address </li>
                                    <li> Enter this order in accordance with the prices, terms, delivery method and specification listed above.</li>
                                    <li> Plesae specify us immediately if you are unable to ship as specify</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section declaration__grid_purchase">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Additional Terms & Conditions</label>
                            <div className="document-edit-block__content" style={{ height: 100 }}>
                                <Form.Item name="additionalTermsAndConditions" style={{ height: '100%' }}>
                                    <Input.TextArea className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section company__signname__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">For, Chemtrade</label>
                        </div>
                    </div>
                    <div className="document-layout__section sign__blank__grid_purchase">
                        <div className="document-edit-block" style={{ height: 100 }}>
                            <div className="document-edit-block__content">
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section signature__grid_purchase pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Authorized Signature/Name</label>
                        </div>
                    </div>
                </div>
                <Form.Item style={{ marginTop: '15px' }}>
                    <Button type="primary" htmlType="submit" className="btn" ghost style={{ width: 75 }}>
                        {(PurchaseOrderMutation.loading || UpdatePurchaseOrderMutation.loading) ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>
                    <Button danger onClick={redirectBack} type="ghost">
                        Cancel
                    </Button>
                </Form.Item>
            </div>
        </Form>
    );
}
export default AddEditPurchaseOrder
